module.exports = __webpack_public_path__ + "static/media/01@2x.da4447b0.png";